import React, { forwardRef, PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { Spaces } from '@ff-os/rendering-shared/coordinates';
import { ContainAspectRatioWithinSquare } from '@ff-os/shared-react/components/aspect-ratio/ContainAspectRatioWithinSquare';
import { selectPhotoById } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import classNames from 'classnames';
import { Paintable } from 'ff-canvas';
import { selectPaintables, selectSpaces } from '../../_redux-photos';
import { PhotoPrintPreview } from './PhotoPrintPreview';
import styles from './PhotoPrintFrame.module.scss';

const _PhotoPrintFrame = forwardRef<HTMLDivElement, Props>(({
    spaces, photo, children, paintables,
    onDragStart = e => e.preventDefault(),
    onDragEnd = e => e.preventDefault(),
    disabled = false
}, photoRef) => (
    <ContainAspectRatioWithinSquare
        width={spaces.sceneWidth} height={spaces.sceneHeight}
        draggable={!disabled} onDragStart={onDragStart} onDragEnd={onDragEnd}>
        <div className={classNames(styles.photo, { [styles.draggable]: !disabled })} ref={photoRef}>
            <PhotoPrintPreview photoId={photo.id} spaces={spaces} paintables={paintables} />
        </div>
        {children}
    </ContainAspectRatioWithinSquare>
));

type OwnProps = PropsWithChildren<{
    photoId: string;
    onDragStart?: React.DragEventHandler;
    onDragEnd?: React.DragEventHandler;
}>;

type Props = OwnProps & {
    spaces: Spaces;
    photo: PhotoPrintsJson.Photo;
    paintables: Paintable[];
    disabled?: boolean;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    spaces: selectSpaces(state, ownProps.photoId),
    paintables: selectPaintables(state, ownProps.photoId),
    photo: selectPhotoById(state, ownProps.photoId)!
});

export const PhotoPrintFrame = connect(
    mapStateToProps,
    null,
    null,
    { forwardRef: true }
)(_PhotoPrintFrame);